// This file is generated by scripts/generate-seo-pages.mjs.
// Do not edit by hand.

export type SeoRoutePage = {
  slug: string;
  appHash: string;
  lang: string;
  hreflang: string;
  locale: string;
  languageName: string;
  title: string;
  description: string;
  h1: string;
  lead: string;
};

export type SeoAlternate = {
  hreflang: string;
  href: string;
};

export type HomeSeoPage = {
  slug: string;
  lang: string;
  hreflang: string;
  locale: string;
  languageName: string;
  title: string;
  description: string;
  h1: string;
  lead: string;
  alternates: SeoAlternate[];
};

export type PrivacySeoPage = {
  slug: string;
  lang: string;
  hreflang: string;
  locale: string;
  languageName: string;
  title: string;
  description: string;
  h1: string;
  lead: string;
  alternates: SeoAlternate[];
};

export const seoRoutePages: SeoRoutePage[] = [
  {
    "slug": "merge-pdf",
    "appHash": "merge",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Merge PDF Online for Free — Combine PDF Files",
    "description": "Merge PDF files online for free. Reorder documents and combine them into one PDF directly in your browser.",
    "h1": "Merge PDF Online",
    "lead": "Combine multiple PDF files into one document. Reorder the files before saving and keep your documents on your device."
  },
  {
    "slug": "ru/obedinit-pdf",
    "appHash": "merge",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Объединить PDF онлайн — PDF911",
    "description": "Объединить PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Объединить PDF онлайн",
    "lead": "Используйте Объединить PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/hebing-pdf",
    "appHash": "merge",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线合并 PDF — PDF911",
    "description": "合并 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线合并 PDF",
    "lead": "在浏览器中在线使用 合并 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/unir-pdf",
    "appHash": "merge",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Unir PDF online — PDF911",
    "description": "Unir PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Unir PDF online",
    "lead": "Usa Unir PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/juntar-pdf",
    "appHash": "merge",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Juntar PDF online — PDF911",
    "description": "Juntar PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Juntar PDF online",
    "lead": "Use Juntar PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-zusammenfuegen",
    "appHash": "merge",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF zusammenfugen online — PDF911",
    "description": "PDF zusammenfugen kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF zusammenfugen online",
    "lead": "PDF zusammenfugen online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/fusionner-pdf",
    "appHash": "merge",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Fusionner PDF online — PDF911",
    "description": "Fusionner PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Fusionner PDF online",
    "lead": "Utilisez Fusionner PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/unire-pdf",
    "appHash": "merge",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Unire PDF online — PDF911",
    "description": "Unire PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Unire PDF online",
    "lead": "Usa Unire PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-samenvoegen",
    "appHash": "merge",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF samenvoegen online — PDF911",
    "description": "PDF samenvoegen gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF samenvoegen online",
    "lead": "Gebruik PDF samenvoegen online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/polacz-pdf",
    "appHash": "merge",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Polacz PDF online — PDF911",
    "description": "Polacz PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Polacz PDF online",
    "lead": "Uzyj Polacz PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-birlestir",
    "appHash": "merge",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF birlestir online — PDF911",
    "description": "PDF birlestir tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF birlestir online",
    "lead": "PDF birlestir aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/gabung-pdf",
    "appHash": "merge",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Gabung PDF online — PDF911",
    "description": "Gabung PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Gabung PDF online",
    "lead": "Gunakan Gabung PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-ketsugou",
    "appHash": "merge",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFを結合オンライン — PDF911",
    "description": "PDFを結合をブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFを結合オンライン",
    "lead": "PDFを結合をブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/gop-pdf",
    "appHash": "merge",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Gộp PDF online — PDF911",
    "description": "Gộp PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Gộp PDF online",
    "lead": "Dùng Gộp PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-byeonghap",
    "appHash": "merge",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF 병합 — PDF911",
    "description": "PDF 병합을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF 병합",
    "lead": "브라우저에서 PDF 병합을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/damj-pdf",
    "appHash": "merge",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "دمج PDF عبر الإنترنت — PDF911",
    "description": "دمج PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "دمج PDF عبر الإنترنت",
    "lead": "استخدم دمج PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-milaye",
    "appHash": "merge",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF मिलाएं ऑनलाइन — PDF911",
    "description": "PDF मिलाएं ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF मिलाएं ऑनलाइन",
    "lead": "ब्राउज़र में PDF मिलाएं ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "compress-pdf",
    "appHash": "compress",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Compress PDF Online — Reduce PDF File Size",
    "description": "Compress PDF online and reduce file size for email, uploads and forms. Best for scanned PDFs and image-heavy documents.",
    "h1": "Compress PDF Online",
    "lead": "Reduce PDF file size for email, messaging, upload forms and archives. Scans and image-heavy PDFs usually compress best."
  },
  {
    "slug": "ru/szhat-pdf",
    "appHash": "compress",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Сжать PDF онлайн — PDF911",
    "description": "Сжать PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Сжать PDF онлайн",
    "lead": "Используйте Сжать PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/yasuo-pdf",
    "appHash": "compress",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线压缩 PDF — PDF911",
    "description": "压缩 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线压缩 PDF",
    "lead": "在浏览器中在线使用 压缩 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/comprimir-pdf",
    "appHash": "compress",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Comprimir PDF online — PDF911",
    "description": "Comprimir PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Comprimir PDF online",
    "lead": "Usa Comprimir PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/comprimir-pdf",
    "appHash": "compress",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Comprimir PDF online — PDF911",
    "description": "Comprimir PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Comprimir PDF online",
    "lead": "Use Comprimir PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-komprimieren",
    "appHash": "compress",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF komprimieren online — PDF911",
    "description": "PDF komprimieren kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF komprimieren online",
    "lead": "PDF komprimieren online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/compresser-pdf",
    "appHash": "compress",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Compresser PDF online — PDF911",
    "description": "Compresser PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Compresser PDF online",
    "lead": "Utilisez Compresser PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/comprimere-pdf",
    "appHash": "compress",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Comprimere PDF online — PDF911",
    "description": "Comprimere PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Comprimere PDF online",
    "lead": "Usa Comprimere PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-comprimeren",
    "appHash": "compress",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF comprimeren online — PDF911",
    "description": "PDF comprimeren gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF comprimeren online",
    "lead": "Gebruik PDF comprimeren online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/kompresuj-pdf",
    "appHash": "compress",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Kompresuj PDF online — PDF911",
    "description": "Kompresuj PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Kompresuj PDF online",
    "lead": "Uzyj Kompresuj PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-sikistir",
    "appHash": "compress",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF sikistir online — PDF911",
    "description": "PDF sikistir tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF sikistir online",
    "lead": "PDF sikistir aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/kompres-pdf",
    "appHash": "compress",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Kompres PDF online — PDF911",
    "description": "Kompres PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Kompres PDF online",
    "lead": "Gunakan Kompres PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-asshuku",
    "appHash": "compress",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFを圧縮オンライン — PDF911",
    "description": "PDFを圧縮をブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFを圧縮オンライン",
    "lead": "PDFを圧縮をブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/nen-pdf",
    "appHash": "compress",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Nén PDF online — PDF911",
    "description": "Nén PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Nén PDF online",
    "lead": "Dùng Nén PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-apchuk",
    "appHash": "compress",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF 압축 — PDF911",
    "description": "PDF 압축을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF 압축",
    "lead": "브라우저에서 PDF 압축을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/daght-pdf",
    "appHash": "compress",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "ضغط PDF عبر الإنترنت — PDF911",
    "description": "ضغط PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "ضغط PDF عبر الإنترنت",
    "lead": "استخدم ضغط PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-compress-kare",
    "appHash": "compress",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF कंप्रेस करें ऑनलाइन — PDF911",
    "description": "PDF कंप्रेस करें ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF कंप्रेस करें ऑनलाइन",
    "lead": "ब्राउज़र में PDF कंप्रेस करें ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "split-pdf",
    "appHash": "split",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Split PDF Online — Extract Pages from PDF",
    "description": "Split PDF online by pages or ranges and download separate PDF files or a ZIP archive.",
    "h1": "Split PDF Online",
    "lead": "Split a PDF into pages or ranges such as 1-3, 5, 7-9. Each range becomes a separate file."
  },
  {
    "slug": "ru/razdelit-pdf",
    "appHash": "split",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Разделить PDF онлайн — PDF911",
    "description": "Разделить PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Разделить PDF онлайн",
    "lead": "Используйте Разделить PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/chaifen-pdf",
    "appHash": "split",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线拆分 PDF — PDF911",
    "description": "拆分 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线拆分 PDF",
    "lead": "在浏览器中在线使用 拆分 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/dividir-pdf",
    "appHash": "split",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Dividir PDF online — PDF911",
    "description": "Dividir PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Dividir PDF online",
    "lead": "Usa Dividir PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/dividir-pdf",
    "appHash": "split",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Dividir PDF online — PDF911",
    "description": "Dividir PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Dividir PDF online",
    "lead": "Use Dividir PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-teilen",
    "appHash": "split",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF teilen online — PDF911",
    "description": "PDF teilen kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF teilen online",
    "lead": "PDF teilen online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/diviser-pdf",
    "appHash": "split",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Diviser PDF online — PDF911",
    "description": "Diviser PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Diviser PDF online",
    "lead": "Utilisez Diviser PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/dividere-pdf",
    "appHash": "split",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Dividere PDF online — PDF911",
    "description": "Dividere PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Dividere PDF online",
    "lead": "Usa Dividere PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-splitsen",
    "appHash": "split",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF splitsen online — PDF911",
    "description": "PDF splitsen gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF splitsen online",
    "lead": "Gebruik PDF splitsen online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/podziel-pdf",
    "appHash": "split",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Podziel PDF online — PDF911",
    "description": "Podziel PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Podziel PDF online",
    "lead": "Uzyj Podziel PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-bol",
    "appHash": "split",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF bol online — PDF911",
    "description": "PDF bol tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF bol online",
    "lead": "PDF bol aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/pisah-pdf",
    "appHash": "split",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Pisah PDF online — PDF911",
    "description": "Pisah PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Pisah PDF online",
    "lead": "Gunakan Pisah PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-bunkatsu",
    "appHash": "split",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFを分割オンライン — PDF911",
    "description": "PDFを分割をブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFを分割オンライン",
    "lead": "PDFを分割をブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/tach-pdf",
    "appHash": "split",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Tách PDF online — PDF911",
    "description": "Tách PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Tách PDF online",
    "lead": "Dùng Tách PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-bunhal",
    "appHash": "split",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF 분할 — PDF911",
    "description": "PDF 분할을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF 분할",
    "lead": "브라우저에서 PDF 분할을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/taqsim-pdf",
    "appHash": "split",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "تقسيم PDF عبر الإنترنت — PDF911",
    "description": "تقسيم PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "تقسيم PDF عبر الإنترنت",
    "lead": "استخدم تقسيم PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-baten",
    "appHash": "split",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF बांटें ऑनलाइन — PDF911",
    "description": "PDF बांटें ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF बांटें ऑनलाइन",
    "lead": "ब्राउज़र में PDF बांटें ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "pdf-to-word",
    "appHash": "pdf-to-docx",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "PDF to Word Online — Convert PDF to DOCX",
    "description": "Convert text-based PDF to Word DOCX online. Extract paragraphs, headings and basic formatting in your browser.",
    "h1": "PDF to Word Online",
    "lead": "Convert a text-based PDF into a DOCX file you can edit. Best for documents that already contain selectable text."
  },
  {
    "slug": "ru/pdf-v-word",
    "appHash": "pdf-to-docx",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "PDF в Word онлайн — PDF911",
    "description": "PDF в Word бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "PDF в Word онлайн",
    "lead": "Используйте PDF в Word онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/pdf-zhuan-word",
    "appHash": "pdf-to-docx",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线PDF 转 Word — PDF911",
    "description": "PDF 转 Word 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线PDF 转 Word",
    "lead": "在浏览器中在线使用 PDF 转 Word。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/pdf-a-word",
    "appHash": "pdf-to-docx",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "PDF a Word online — PDF911",
    "description": "PDF a Word gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "PDF a Word online",
    "lead": "Usa PDF a Word online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/pdf-para-word",
    "appHash": "pdf-to-docx",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "PDF para Word online — PDF911",
    "description": "PDF para Word gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "PDF para Word online",
    "lead": "Use PDF para Word online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-in-word",
    "appHash": "pdf-to-docx",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF in Word online — PDF911",
    "description": "PDF in Word kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF in Word online",
    "lead": "PDF in Word online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/pdf-en-word",
    "appHash": "pdf-to-docx",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "PDF en Word online — PDF911",
    "description": "PDF en Word gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "PDF en Word online",
    "lead": "Utilisez PDF en Word en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/pdf-in-word",
    "appHash": "pdf-to-docx",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "PDF in Word online — PDF911",
    "description": "PDF in Word gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "PDF in Word online",
    "lead": "Usa PDF in Word online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-naar-word",
    "appHash": "pdf-to-docx",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF naar Word online — PDF911",
    "description": "PDF naar Word gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF naar Word online",
    "lead": "Gebruik PDF naar Word online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/pdf-na-word",
    "appHash": "pdf-to-docx",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "PDF na Word online — PDF911",
    "description": "PDF na Word za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "PDF na Word online",
    "lead": "Uzyj PDF na Word online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-word",
    "appHash": "pdf-to-docx",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF Word online — PDF911",
    "description": "PDF Word tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF Word online",
    "lead": "PDF Word aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/pdf-ke-word",
    "appHash": "pdf-to-docx",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "PDF ke Word online — PDF911",
    "description": "PDF ke Word gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "PDF ke Word online",
    "lead": "Gunakan PDF ke Word online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-word-henkan",
    "appHash": "pdf-to-docx",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFからWordオンライン — PDF911",
    "description": "PDFからWordをブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFからWordオンライン",
    "lead": "PDFからWordをブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/pdf-sang-word",
    "appHash": "pdf-to-docx",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "PDF sang Word online — PDF911",
    "description": "PDF sang Word miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "PDF sang Word online",
    "lead": "Dùng PDF sang Word online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-word-byeonhwan",
    "appHash": "pdf-to-docx",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF를 Word로 — PDF911",
    "description": "PDF를 Word로을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF를 Word로",
    "lead": "브라우저에서 PDF를 Word로을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/pdf-ila-word",
    "appHash": "pdf-to-docx",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "PDF إلى Word عبر الإنترنت — PDF911",
    "description": "PDF إلى Word مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "PDF إلى Word عبر الإنترنت",
    "lead": "استخدم PDF إلى Word عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-se-word",
    "appHash": "pdf-to-docx",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF से Word ऑनलाइन — PDF911",
    "description": "PDF से Word ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF से Word ऑनलाइन",
    "lead": "ब्राउज़र में PDF से Word ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "word-to-pdf",
    "appHash": "docx-to-pdf",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Word to PDF Online — Convert DOCX to PDF",
    "description": "Convert Word DOCX files to PDF online for sharing, printing and archiving directly in your browser.",
    "h1": "Word to PDF Online",
    "lead": "Save a DOCX document as PDF for email, printing, upload forms or archives."
  },
  {
    "slug": "ru/word-v-pdf",
    "appHash": "docx-to-pdf",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Word в PDF онлайн — PDF911",
    "description": "Word в PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Word в PDF онлайн",
    "lead": "Используйте Word в PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/word-zhuan-pdf",
    "appHash": "docx-to-pdf",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线Word 转 PDF — PDF911",
    "description": "Word 转 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线Word 转 PDF",
    "lead": "在浏览器中在线使用 Word 转 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/word-a-pdf",
    "appHash": "docx-to-pdf",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Word a PDF online — PDF911",
    "description": "Word a PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Word a PDF online",
    "lead": "Usa Word a PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/word-para-pdf",
    "appHash": "docx-to-pdf",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Word para PDF online — PDF911",
    "description": "Word para PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Word para PDF online",
    "lead": "Use Word para PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/word-in-pdf",
    "appHash": "docx-to-pdf",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "Word in PDF online — PDF911",
    "description": "Word in PDF kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "Word in PDF online",
    "lead": "Word in PDF online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/word-en-pdf",
    "appHash": "docx-to-pdf",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Word en PDF online — PDF911",
    "description": "Word en PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Word en PDF online",
    "lead": "Utilisez Word en PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/word-in-pdf",
    "appHash": "docx-to-pdf",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Word in PDF online — PDF911",
    "description": "Word in PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Word in PDF online",
    "lead": "Usa Word in PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/word-naar-pdf",
    "appHash": "docx-to-pdf",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "Word naar PDF online — PDF911",
    "description": "Word naar PDF gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "Word naar PDF online",
    "lead": "Gebruik Word naar PDF online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/word-na-pdf",
    "appHash": "docx-to-pdf",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Word na PDF online — PDF911",
    "description": "Word na PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Word na PDF online",
    "lead": "Uzyj Word na PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/word-pdf",
    "appHash": "docx-to-pdf",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "Word PDF online — PDF911",
    "description": "Word PDF tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "Word PDF online",
    "lead": "Word PDF aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/word-ke-pdf",
    "appHash": "docx-to-pdf",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Word ke PDF online — PDF911",
    "description": "Word ke PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Word ke PDF online",
    "lead": "Gunakan Word ke PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/word-pdf-henkan",
    "appHash": "docx-to-pdf",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "WordからPDFオンライン — PDF911",
    "description": "WordからPDFをブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "WordからPDFオンライン",
    "lead": "WordからPDFをブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/word-sang-pdf",
    "appHash": "docx-to-pdf",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Word sang PDF online — PDF911",
    "description": "Word sang PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Word sang PDF online",
    "lead": "Dùng Word sang PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/word-pdf-byeonhwan",
    "appHash": "docx-to-pdf",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 Word를 PDF로 — PDF911",
    "description": "Word를 PDF로을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 Word를 PDF로",
    "lead": "브라우저에서 Word를 PDF로을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/word-ila-pdf",
    "appHash": "docx-to-pdf",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "Word إلى PDF عبر الإنترنت — PDF911",
    "description": "Word إلى PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "Word إلى PDF عبر الإنترنت",
    "lead": "استخدم Word إلى PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/word-se-pdf",
    "appHash": "docx-to-pdf",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "Word से PDF ऑनलाइन — PDF911",
    "description": "Word से PDF ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "Word से PDF ऑनलाइन",
    "lead": "ब्राउज़र में Word से PDF ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "jpg-to-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "JPG to PDF Online — Images to PDF",
    "description": "Convert JPG, JPEG and PNG images to one PDF online. Reorder photos before saving.",
    "h1": "JPG to PDF Online",
    "lead": "Convert JPG, JPEG and PNG images to one PDF online. Reorder photos before saving."
  },
  {
    "slug": "ru/jpg-v-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "JPG в PDF онлайн — PDF911",
    "description": "JPG в PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "JPG в PDF онлайн",
    "lead": "Используйте JPG в PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/jpg-zhuan-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线JPG 转 PDF — PDF911",
    "description": "JPG 转 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线JPG 转 PDF",
    "lead": "在浏览器中在线使用 JPG 转 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/jpg-a-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "JPG a PDF online — PDF911",
    "description": "JPG a PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "JPG a PDF online",
    "lead": "Usa JPG a PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/jpg-para-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "JPG para PDF online — PDF911",
    "description": "JPG para PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "JPG para PDF online",
    "lead": "Use JPG para PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/jpg-in-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "JPG in PDF online — PDF911",
    "description": "JPG in PDF kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "JPG in PDF online",
    "lead": "JPG in PDF online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/jpg-en-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "JPG en PDF online — PDF911",
    "description": "JPG en PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "JPG en PDF online",
    "lead": "Utilisez JPG en PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/jpg-in-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "JPG in PDF online — PDF911",
    "description": "JPG in PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "JPG in PDF online",
    "lead": "Usa JPG in PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/jpg-naar-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "JPG naar PDF online — PDF911",
    "description": "JPG naar PDF gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "JPG naar PDF online",
    "lead": "Gebruik JPG naar PDF online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/jpg-na-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "JPG na PDF online — PDF911",
    "description": "JPG na PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "JPG na PDF online",
    "lead": "Uzyj JPG na PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/jpg-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "JPG PDF online — PDF911",
    "description": "JPG PDF tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "JPG PDF online",
    "lead": "JPG PDF aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/jpg-ke-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "JPG ke PDF online — PDF911",
    "description": "JPG ke PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "JPG ke PDF online",
    "lead": "Gunakan JPG ke PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/jpg-pdf-henkan",
    "appHash": "jpg-to-pdf",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "JPGからPDFオンライン — PDF911",
    "description": "JPGからPDFをブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "JPGからPDFオンライン",
    "lead": "JPGからPDFをブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/jpg-sang-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "JPG sang PDF online — PDF911",
    "description": "JPG sang PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "JPG sang PDF online",
    "lead": "Dùng JPG sang PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/jpg-pdf-byeonhwan",
    "appHash": "jpg-to-pdf",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 JPG를 PDF로 — PDF911",
    "description": "JPG를 PDF로을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 JPG를 PDF로",
    "lead": "브라우저에서 JPG를 PDF로을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/jpg-ila-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "JPG إلى PDF عبر الإنترنت — PDF911",
    "description": "JPG إلى PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "JPG إلى PDF عبر الإنترنت",
    "lead": "استخدم JPG إلى PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/jpg-se-pdf",
    "appHash": "jpg-to-pdf",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "JPG से PDF ऑनलाइन — PDF911",
    "description": "JPG से PDF ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "JPG से PDF ऑनलाइन",
    "lead": "ब्राउज़र में JPG से PDF ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "pdf-to-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "PDF to JPG Online — Convert PDF Pages to Images",
    "description": "Convert PDF pages to JPG or PNG images online and download individual files or a ZIP archive.",
    "h1": "PDF to JPG Online",
    "lead": "Convert PDF pages to JPG or PNG images online and download individual files or a ZIP archive."
  },
  {
    "slug": "ru/pdf-v-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "PDF в JPG онлайн — PDF911",
    "description": "PDF в JPG бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "PDF в JPG онлайн",
    "lead": "Используйте PDF в JPG онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/pdf-zhuan-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线PDF 转 JPG — PDF911",
    "description": "PDF 转 JPG 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线PDF 转 JPG",
    "lead": "在浏览器中在线使用 PDF 转 JPG。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/pdf-a-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "PDF a JPG online — PDF911",
    "description": "PDF a JPG gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "PDF a JPG online",
    "lead": "Usa PDF a JPG online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/pdf-para-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "PDF para JPG online — PDF911",
    "description": "PDF para JPG gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "PDF para JPG online",
    "lead": "Use PDF para JPG online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-in-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF in JPG online — PDF911",
    "description": "PDF in JPG kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF in JPG online",
    "lead": "PDF in JPG online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/pdf-en-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "PDF en JPG online — PDF911",
    "description": "PDF en JPG gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "PDF en JPG online",
    "lead": "Utilisez PDF en JPG en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/pdf-in-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "PDF in JPG online — PDF911",
    "description": "PDF in JPG gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "PDF in JPG online",
    "lead": "Usa PDF in JPG online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-naar-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF naar JPG online — PDF911",
    "description": "PDF naar JPG gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF naar JPG online",
    "lead": "Gebruik PDF naar JPG online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/pdf-na-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "PDF na JPG online — PDF911",
    "description": "PDF na JPG za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "PDF na JPG online",
    "lead": "Uzyj PDF na JPG online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF JPG online — PDF911",
    "description": "PDF JPG tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF JPG online",
    "lead": "PDF JPG aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/pdf-ke-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "PDF ke JPG online — PDF911",
    "description": "PDF ke JPG gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "PDF ke JPG online",
    "lead": "Gunakan PDF ke JPG online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-jpg-henkan",
    "appHash": "pdf-to-jpg",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFからJPGオンライン — PDF911",
    "description": "PDFからJPGをブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFからJPGオンライン",
    "lead": "PDFからJPGをブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/pdf-sang-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "PDF sang JPG online — PDF911",
    "description": "PDF sang JPG miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "PDF sang JPG online",
    "lead": "Dùng PDF sang JPG online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-jpg-byeonhwan",
    "appHash": "pdf-to-jpg",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF를 JPG로 — PDF911",
    "description": "PDF를 JPG로을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF를 JPG로",
    "lead": "브라우저에서 PDF를 JPG로을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/pdf-ila-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "PDF إلى JPG عبر الإنترنت — PDF911",
    "description": "PDF إلى JPG مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "PDF إلى JPG عبر الإنترنت",
    "lead": "استخدم PDF إلى JPG عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-se-jpg",
    "appHash": "pdf-to-jpg",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF से JPG ऑनलाइन — PDF911",
    "description": "PDF से JPG ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF से JPG ऑनलाइन",
    "lead": "ब्राउज़र में PDF से JPG ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "edit-pdf",
    "appHash": "edit",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "PDF Editor Online — Edit PDF for Free",
    "description": "Edit PDF online by adding text, highlights, images and annotations directly in your browser.",
    "h1": "PDF Editor Online",
    "lead": "Edit PDF online by adding text, highlights, images and annotations directly in your browser."
  },
  {
    "slug": "ru/redaktirovat-pdf",
    "appHash": "edit",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Редактировать PDF онлайн — PDF911",
    "description": "Редактировать PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Редактировать PDF онлайн",
    "lead": "Используйте Редактировать PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/bianji-pdf",
    "appHash": "edit",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线编辑 PDF — PDF911",
    "description": "编辑 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线编辑 PDF",
    "lead": "在浏览器中在线使用 编辑 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/editar-pdf",
    "appHash": "edit",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Editar PDF online — PDF911",
    "description": "Editar PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Editar PDF online",
    "lead": "Usa Editar PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/editar-pdf",
    "appHash": "edit",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Editar PDF online — PDF911",
    "description": "Editar PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Editar PDF online",
    "lead": "Use Editar PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-bearbeiten",
    "appHash": "edit",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF bearbeiten online — PDF911",
    "description": "PDF bearbeiten kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF bearbeiten online",
    "lead": "PDF bearbeiten online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/modifier-pdf",
    "appHash": "edit",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Modifier PDF online — PDF911",
    "description": "Modifier PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Modifier PDF online",
    "lead": "Utilisez Modifier PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/modificare-pdf",
    "appHash": "edit",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Modificare PDF online — PDF911",
    "description": "Modificare PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Modificare PDF online",
    "lead": "Usa Modificare PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-bewerken",
    "appHash": "edit",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF bewerken online — PDF911",
    "description": "PDF bewerken gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF bewerken online",
    "lead": "Gebruik PDF bewerken online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/edytuj-pdf",
    "appHash": "edit",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Edytuj PDF online — PDF911",
    "description": "Edytuj PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Edytuj PDF online",
    "lead": "Uzyj Edytuj PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-duzenle",
    "appHash": "edit",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF duzenle online — PDF911",
    "description": "PDF duzenle tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF duzenle online",
    "lead": "PDF duzenle aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/edit-pdf",
    "appHash": "edit",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Edit PDF online — PDF911",
    "description": "Edit PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Edit PDF online",
    "lead": "Gunakan Edit PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-henshu",
    "appHash": "edit",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFを編集オンライン — PDF911",
    "description": "PDFを編集をブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFを編集オンライン",
    "lead": "PDFを編集をブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/chinh-sua-pdf",
    "appHash": "edit",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Chỉnh sửa PDF online — PDF911",
    "description": "Chỉnh sửa PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Chỉnh sửa PDF online",
    "lead": "Dùng Chỉnh sửa PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-pyeonjip",
    "appHash": "edit",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF 편집 — PDF911",
    "description": "PDF 편집을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF 편집",
    "lead": "브라우저에서 PDF 편집을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/tahrir-pdf",
    "appHash": "edit",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "تحرير PDF عبر الإنترنت — PDF911",
    "description": "تحرير PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "تحرير PDF عبر الإنترنت",
    "lead": "استخدم تحرير PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-edit-kare",
    "appHash": "edit",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF एडिट करें ऑनलाइन — PDF911",
    "description": "PDF एडिट करें ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF एडिट करें ऑनलाइन",
    "lead": "ब्राउज़र में PDF एडिट करें ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "sign-pdf",
    "appHash": "sign",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Sign PDF Online — Add a Signature to PDF",
    "description": "Sign PDF online by adding a visual signature, date, text or check mark to a document.",
    "h1": "Sign PDF Online",
    "lead": "Sign PDF online by adding a visual signature, date, text or check mark to a document."
  },
  {
    "slug": "ru/podpisat-pdf",
    "appHash": "sign",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Подписать PDF онлайн — PDF911",
    "description": "Подписать PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Подписать PDF онлайн",
    "lead": "Используйте Подписать PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/qianshu-pdf",
    "appHash": "sign",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线签署 PDF — PDF911",
    "description": "签署 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线签署 PDF",
    "lead": "在浏览器中在线使用 签署 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/firmar-pdf",
    "appHash": "sign",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Firmar PDF online — PDF911",
    "description": "Firmar PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Firmar PDF online",
    "lead": "Usa Firmar PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/assinar-pdf",
    "appHash": "sign",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Assinar PDF online — PDF911",
    "description": "Assinar PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Assinar PDF online",
    "lead": "Use Assinar PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-unterschreiben",
    "appHash": "sign",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF unterschreiben online — PDF911",
    "description": "PDF unterschreiben kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF unterschreiben online",
    "lead": "PDF unterschreiben online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/signer-pdf",
    "appHash": "sign",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Signer PDF online — PDF911",
    "description": "Signer PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Signer PDF online",
    "lead": "Utilisez Signer PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/firmare-pdf",
    "appHash": "sign",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Firmare PDF online — PDF911",
    "description": "Firmare PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Firmare PDF online",
    "lead": "Usa Firmare PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-ondertekenen",
    "appHash": "sign",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF ondertekenen online — PDF911",
    "description": "PDF ondertekenen gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF ondertekenen online",
    "lead": "Gebruik PDF ondertekenen online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/podpisz-pdf",
    "appHash": "sign",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Podpisz PDF online — PDF911",
    "description": "Podpisz PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Podpisz PDF online",
    "lead": "Uzyj Podpisz PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-imzala",
    "appHash": "sign",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF imzala online — PDF911",
    "description": "PDF imzala tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF imzala online",
    "lead": "PDF imzala aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/tanda-tangan-pdf",
    "appHash": "sign",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Tanda tangan PDF online — PDF911",
    "description": "Tanda tangan PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Tanda tangan PDF online",
    "lead": "Gunakan Tanda tangan PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-shomei",
    "appHash": "sign",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFに署名オンライン — PDF911",
    "description": "PDFに署名をブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFに署名オンライン",
    "lead": "PDFに署名をブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/ky-pdf",
    "appHash": "sign",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Ký PDF online — PDF911",
    "description": "Ký PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Ký PDF online",
    "lead": "Dùng Ký PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-seomyeong",
    "appHash": "sign",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF 서명 — PDF911",
    "description": "PDF 서명을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF 서명",
    "lead": "브라우저에서 PDF 서명을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/tawqie-pdf",
    "appHash": "sign",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "توقيع PDF عبر الإنترنت — PDF911",
    "description": "توقيع PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "توقيع PDF عبر الإنترنت",
    "lead": "استخدم توقيع PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-sign-kare",
    "appHash": "sign",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF साइन करें ऑनलाइन — PDF911",
    "description": "PDF साइन करें ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF साइन करें ऑनलाइन",
    "lead": "ब्राउज़र में PDF साइन करें ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "rotate-pdf",
    "appHash": "rotate",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Rotate PDF Online — Rotate PDF Pages",
    "description": "Rotate one page or the whole PDF by 90, 180 or 270 degrees online.",
    "h1": "Rotate PDF Online",
    "lead": "Rotate one page or the whole PDF by 90, 180 or 270 degrees online."
  },
  {
    "slug": "ru/povernut-pdf",
    "appHash": "rotate",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Повернуть PDF онлайн — PDF911",
    "description": "Повернуть PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Повернуть PDF онлайн",
    "lead": "Используйте Повернуть PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/xuanzhuan-pdf",
    "appHash": "rotate",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线旋转 PDF — PDF911",
    "description": "旋转 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线旋转 PDF",
    "lead": "在浏览器中在线使用 旋转 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/rotar-pdf",
    "appHash": "rotate",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Rotar PDF online — PDF911",
    "description": "Rotar PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Rotar PDF online",
    "lead": "Usa Rotar PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/girar-pdf",
    "appHash": "rotate",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Girar PDF online — PDF911",
    "description": "Girar PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Girar PDF online",
    "lead": "Use Girar PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-drehen",
    "appHash": "rotate",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF drehen online — PDF911",
    "description": "PDF drehen kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF drehen online",
    "lead": "PDF drehen online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/faire-pivoter-pdf",
    "appHash": "rotate",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Faire pivoter PDF online — PDF911",
    "description": "Faire pivoter PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Faire pivoter PDF online",
    "lead": "Utilisez Faire pivoter PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/ruotare-pdf",
    "appHash": "rotate",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Ruotare PDF online — PDF911",
    "description": "Ruotare PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Ruotare PDF online",
    "lead": "Usa Ruotare PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-draaien",
    "appHash": "rotate",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF draaien online — PDF911",
    "description": "PDF draaien gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF draaien online",
    "lead": "Gebruik PDF draaien online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/obroc-pdf",
    "appHash": "rotate",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Obroc PDF online — PDF911",
    "description": "Obroc PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Obroc PDF online",
    "lead": "Uzyj Obroc PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-dondur",
    "appHash": "rotate",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF dondur online — PDF911",
    "description": "PDF dondur tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF dondur online",
    "lead": "PDF dondur aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/putar-pdf",
    "appHash": "rotate",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Putar PDF online — PDF911",
    "description": "Putar PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Putar PDF online",
    "lead": "Gunakan Putar PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-kaiten",
    "appHash": "rotate",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFを回転オンライン — PDF911",
    "description": "PDFを回転をブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFを回転オンライン",
    "lead": "PDFを回転をブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/xoay-pdf",
    "appHash": "rotate",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Xoay PDF online — PDF911",
    "description": "Xoay PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Xoay PDF online",
    "lead": "Dùng Xoay PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-hoejeon",
    "appHash": "rotate",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF 회전 — PDF911",
    "description": "PDF 회전을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF 회전",
    "lead": "브라우저에서 PDF 회전을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/tadweer-pdf",
    "appHash": "rotate",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "تدوير PDF عبر الإنترنت — PDF911",
    "description": "تدوير PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "تدوير PDF عبر الإنترنت",
    "lead": "استخدم تدوير PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-ghumaye",
    "appHash": "rotate",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF घुमाएं ऑनलाइन — PDF911",
    "description": "PDF घुमाएं ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF घुमाएं ऑनलाइन",
    "lead": "ब्राउज़र में PDF घुमाएं ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "pdf-to-text",
    "appHash": "pdf-to-txt",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "PDF to Text Online — Extract Text from PDF",
    "description": "Extract selectable text from a PDF and copy it or download a TXT file.",
    "h1": "PDF to Text Online",
    "lead": "Extract selectable text from a PDF and copy it or download a TXT file."
  },
  {
    "slug": "ru/pdf-v-tekst",
    "appHash": "pdf-to-txt",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "PDF в текст онлайн — PDF911",
    "description": "PDF в текст бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "PDF в текст онлайн",
    "lead": "Используйте PDF в текст онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/pdf-zhuan-wenben",
    "appHash": "pdf-to-txt",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线PDF 转文本 — PDF911",
    "description": "PDF 转文本 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线PDF 转文本",
    "lead": "在浏览器中在线使用 PDF 转文本。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/pdf-a-texto",
    "appHash": "pdf-to-txt",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "PDF a texto online — PDF911",
    "description": "PDF a texto gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "PDF a texto online",
    "lead": "Usa PDF a texto online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/pdf-para-texto",
    "appHash": "pdf-to-txt",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "PDF para texto online — PDF911",
    "description": "PDF para texto gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "PDF para texto online",
    "lead": "Use PDF para texto online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-in-text",
    "appHash": "pdf-to-txt",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF in Text online — PDF911",
    "description": "PDF in Text kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF in Text online",
    "lead": "PDF in Text online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/pdf-en-texte",
    "appHash": "pdf-to-txt",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "PDF en texte online — PDF911",
    "description": "PDF en texte gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "PDF en texte online",
    "lead": "Utilisez PDF en texte en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/pdf-in-testo",
    "appHash": "pdf-to-txt",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "PDF in testo online — PDF911",
    "description": "PDF in testo gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "PDF in testo online",
    "lead": "Usa PDF in testo online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-naar-tekst",
    "appHash": "pdf-to-txt",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF naar tekst online — PDF911",
    "description": "PDF naar tekst gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF naar tekst online",
    "lead": "Gebruik PDF naar tekst online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/pdf-na-tekst",
    "appHash": "pdf-to-txt",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "PDF na tekst online — PDF911",
    "description": "PDF na tekst za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "PDF na tekst online",
    "lead": "Uzyj PDF na tekst online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-metin",
    "appHash": "pdf-to-txt",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF metin online — PDF911",
    "description": "PDF metin tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF metin online",
    "lead": "PDF metin aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/pdf-ke-teks",
    "appHash": "pdf-to-txt",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "PDF ke teks online — PDF911",
    "description": "PDF ke teks gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "PDF ke teks online",
    "lead": "Gunakan PDF ke teks online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-text-henkan",
    "appHash": "pdf-to-txt",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFからテキストオンライン — PDF911",
    "description": "PDFからテキストをブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFからテキストオンライン",
    "lead": "PDFからテキストをブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/pdf-sang-van-ban",
    "appHash": "pdf-to-txt",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "PDF sang văn bản online — PDF911",
    "description": "PDF sang văn bản miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "PDF sang văn bản online",
    "lead": "Dùng PDF sang văn bản online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-text-byeonhwan",
    "appHash": "pdf-to-txt",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF를 텍스트로 — PDF911",
    "description": "PDF를 텍스트로을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF를 텍스트로",
    "lead": "브라우저에서 PDF를 텍스트로을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/pdf-ila-nass",
    "appHash": "pdf-to-txt",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "PDF إلى نص عبر الإنترنت — PDF911",
    "description": "PDF إلى نص مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "PDF إلى نص عبر الإنترنت",
    "lead": "استخدم PDF إلى نص عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-se-text",
    "appHash": "pdf-to-txt",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF से टेक्स्ट ऑनलाइन — PDF911",
    "description": "PDF से टेक्स्ट ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF से टेक्स्ट ऑनलाइन",
    "lead": "ब्राउज़र में PDF से टेक्स्ट ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "organize-pdf",
    "appHash": "organize",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Organize PDF Online — Delete, Reorder and Extract Pages",
    "description": "Organize PDF pages online: delete pages, reorder pages, rotate pages and save a new PDF.",
    "h1": "Organize PDF Pages",
    "lead": "Organize PDF pages online: delete pages, reorder pages, rotate pages and save a new PDF."
  },
  {
    "slug": "ru/organizovat-pdf",
    "appHash": "organize",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Организовать PDF онлайн — PDF911",
    "description": "Организовать PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Организовать PDF онлайн",
    "lead": "Используйте Организовать PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/zhengli-pdf",
    "appHash": "organize",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线整理 PDF — PDF911",
    "description": "整理 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线整理 PDF",
    "lead": "在浏览器中在线使用 整理 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/organizar-pdf",
    "appHash": "organize",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Organizar PDF online — PDF911",
    "description": "Organizar PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Organizar PDF online",
    "lead": "Usa Organizar PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/organizar-pdf",
    "appHash": "organize",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Organizar PDF online — PDF911",
    "description": "Organizar PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Organizar PDF online",
    "lead": "Use Organizar PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/pdf-organisieren",
    "appHash": "organize",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF organisieren online — PDF911",
    "description": "PDF organisieren kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "PDF organisieren online",
    "lead": "PDF organisieren online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/organiser-pdf",
    "appHash": "organize",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Organiser PDF online — PDF911",
    "description": "Organiser PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Organiser PDF online",
    "lead": "Utilisez Organiser PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/organizzare-pdf",
    "appHash": "organize",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Organizzare PDF online — PDF911",
    "description": "Organizzare PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Organizzare PDF online",
    "lead": "Usa Organizzare PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/pdf-organiseren",
    "appHash": "organize",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF organiseren online — PDF911",
    "description": "PDF organiseren gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "PDF organiseren online",
    "lead": "Gebruik PDF organiseren online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/organizuj-pdf",
    "appHash": "organize",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Organizuj PDF online — PDF911",
    "description": "Organizuj PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Organizuj PDF online",
    "lead": "Uzyj Organizuj PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/pdf-duzenle-sayfalar",
    "appHash": "organize",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF sayfalari duzenle online — PDF911",
    "description": "PDF sayfalari duzenle tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "PDF sayfalari duzenle online",
    "lead": "PDF sayfalari duzenle aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/atur-pdf",
    "appHash": "organize",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Atur PDF online — PDF911",
    "description": "Atur PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Atur PDF online",
    "lead": "Gunakan Atur PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/pdf-seiri",
    "appHash": "organize",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDFを整理オンライン — PDF911",
    "description": "PDFを整理をブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "PDFを整理オンライン",
    "lead": "PDFを整理をブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/sap-xep-pdf",
    "appHash": "organize",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Sắp xếp PDF online — PDF911",
    "description": "Sắp xếp PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Sắp xếp PDF online",
    "lead": "Dùng Sắp xếp PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/pdf-jeongri",
    "appHash": "organize",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 PDF 정리 — PDF911",
    "description": "PDF 정리을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 PDF 정리",
    "lead": "브라우저에서 PDF 정리을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/tanzim-pdf",
    "appHash": "organize",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "تنظيم PDF عبر الإنترنت — PDF911",
    "description": "تنظيم PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "تنظيم PDF عبر الإنترنت",
    "lead": "استخدم تنظيم PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/pdf-vyavasthit-kare",
    "appHash": "organize",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF व्यवस्थित करें ऑनलाइन — PDF911",
    "description": "PDF व्यवस्थित करें ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "PDF व्यवस्थित करें ऑनलाइन",
    "lead": "ब्राउज़र में PDF व्यवस्थित करें ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "excel-to-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Excel to PDF Online — Convert XLSX to PDF",
    "description": "Convert XLSX spreadsheets to PDF online with table layout and page orientation options.",
    "h1": "Excel to PDF Online",
    "lead": "Convert XLSX spreadsheets to PDF online with table layout and page orientation options."
  },
  {
    "slug": "ru/excel-v-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Excel в PDF онлайн — PDF911",
    "description": "Excel в PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "Excel в PDF онлайн",
    "lead": "Используйте Excel в PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/excel-zhuan-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线Excel 转 PDF — PDF911",
    "description": "Excel 转 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线Excel 转 PDF",
    "lead": "在浏览器中在线使用 Excel 转 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/excel-a-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Excel a PDF online — PDF911",
    "description": "Excel a PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "Excel a PDF online",
    "lead": "Usa Excel a PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/excel-para-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Excel para PDF online — PDF911",
    "description": "Excel para PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "Excel para PDF online",
    "lead": "Use Excel para PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/excel-in-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "Excel in PDF online — PDF911",
    "description": "Excel in PDF kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "Excel in PDF online",
    "lead": "Excel in PDF online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/excel-en-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Excel en PDF online — PDF911",
    "description": "Excel en PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "Excel en PDF online",
    "lead": "Utilisez Excel en PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/excel-in-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Excel in PDF online — PDF911",
    "description": "Excel in PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "Excel in PDF online",
    "lead": "Usa Excel in PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/excel-naar-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "Excel naar PDF online — PDF911",
    "description": "Excel naar PDF gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "Excel naar PDF online",
    "lead": "Gebruik Excel naar PDF online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/excel-na-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Excel na PDF online — PDF911",
    "description": "Excel na PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "Excel na PDF online",
    "lead": "Uzyj Excel na PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/excel-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "Excel PDF online — PDF911",
    "description": "Excel PDF tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "Excel PDF online",
    "lead": "Excel PDF aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/excel-ke-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Excel ke PDF online — PDF911",
    "description": "Excel ke PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "Excel ke PDF online",
    "lead": "Gunakan Excel ke PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/excel-pdf-henkan",
    "appHash": "xlsx-to-pdf",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "ExcelからPDFオンライン — PDF911",
    "description": "ExcelからPDFをブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "ExcelからPDFオンライン",
    "lead": "ExcelからPDFをブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/excel-sang-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Excel sang PDF online — PDF911",
    "description": "Excel sang PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "Excel sang PDF online",
    "lead": "Dùng Excel sang PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/excel-pdf-byeonhwan",
    "appHash": "xlsx-to-pdf",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 Excel을 PDF로 — PDF911",
    "description": "Excel을 PDF로을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 Excel을 PDF로",
    "lead": "브라우저에서 Excel을 PDF로을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/excel-ila-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "Excel إلى PDF عبر الإنترنت — PDF911",
    "description": "Excel إلى PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "Excel إلى PDF عبر الإنترنت",
    "lead": "استخدم Excel إلى PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/excel-se-pdf",
    "appHash": "xlsx-to-pdf",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "Excel से PDF ऑनलाइन — PDF911",
    "description": "Excel से PDF ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "Excel से PDF ऑनलाइन",
    "lead": "ब्राउज़र में Excel से PDF ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  },
  {
    "slug": "csv-to-pdf",
    "appHash": "csv-to-pdf",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "CSV to PDF Online — Convert CSV Tables to PDF",
    "description": "Convert CSV or TSV data into a clean PDF report with delimiter and page options.",
    "h1": "CSV to PDF Online",
    "lead": "Convert CSV or TSV data into a clean PDF report with delimiter and page options."
  },
  {
    "slug": "ru/csv-v-pdf",
    "appHash": "csv-to-pdf",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "CSV в PDF онлайн — PDF911",
    "description": "CSV в PDF бесплатно онлайн прямо в браузере. Быстрый PDF-инструмент для повседневных документов.",
    "h1": "CSV в PDF онлайн",
    "lead": "Используйте CSV в PDF онлайн в браузере. Когда инструмент это поддерживает, файл обрабатывается локально на вашем устройстве."
  },
  {
    "slug": "zh/csv-zhuan-pdf",
    "appHash": "csv-to-pdf",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "在线CSV 转 PDF — PDF911",
    "description": "CSV 转 PDF 免费在线使用，直接在浏览器中处理。适合日常 PDF 文档。",
    "h1": "在线CSV 转 PDF",
    "lead": "在浏览器中在线使用 CSV 转 PDF。如果工具支持，文件会在您的设备本地处理。"
  },
  {
    "slug": "es/csv-a-pdf",
    "appHash": "csv-to-pdf",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "CSV a PDF online — PDF911",
    "description": "CSV a PDF gratis directamente en el navegador. Herramienta PDF rapida para documentos diarios.",
    "h1": "CSV a PDF online",
    "lead": "Usa CSV a PDF online en el navegador. El archivo se procesa localmente siempre que la herramienta lo permite."
  },
  {
    "slug": "pt/csv-para-pdf",
    "appHash": "csv-to-pdf",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "CSV para PDF online — PDF911",
    "description": "CSV para PDF gratis diretamente no navegador. Ferramenta PDF rapida para documentos do dia a dia.",
    "h1": "CSV para PDF online",
    "lead": "Use CSV para PDF online no navegador. O arquivo e processado localmente sempre que a ferramenta permite."
  },
  {
    "slug": "de/csv-in-pdf",
    "appHash": "csv-to-pdf",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "CSV in PDF online — PDF911",
    "description": "CSV in PDF kostenlos direkt im Browser. Schnelles PDF-Tool fur den Dokumentenalltag.",
    "h1": "CSV in PDF online",
    "lead": "CSV in PDF online im Browser nutzen. Die Datei wird nach Moglichkeit lokal auf Ihrem Gerat verarbeitet."
  },
  {
    "slug": "fr/csv-en-pdf",
    "appHash": "csv-to-pdf",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "CSV en PDF online — PDF911",
    "description": "CSV en PDF gratuitement dans le navigateur. Outil PDF rapide pour les documents du quotidien.",
    "h1": "CSV en PDF online",
    "lead": "Utilisez CSV en PDF en ligne dans le navigateur. Le fichier est traite localement lorsque l outil le permet."
  },
  {
    "slug": "it/csv-in-pdf",
    "appHash": "csv-to-pdf",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "CSV in PDF online — PDF911",
    "description": "CSV in PDF gratis direttamente nel browser. Strumento PDF rapido per documenti quotidiani.",
    "h1": "CSV in PDF online",
    "lead": "Usa CSV in PDF online nel browser. Il file viene elaborato localmente quando lo strumento lo consente."
  },
  {
    "slug": "nl/csv-naar-pdf",
    "appHash": "csv-to-pdf",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "CSV naar PDF online — PDF911",
    "description": "CSV naar PDF gratis direct in de browser. Snelle PDF-tool voor dagelijks documentwerk.",
    "h1": "CSV naar PDF online",
    "lead": "Gebruik CSV naar PDF online in de browser. Het bestand wordt lokaal verwerkt wanneer de tool dat ondersteunt."
  },
  {
    "slug": "pl/csv-na-pdf",
    "appHash": "csv-to-pdf",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "CSV na PDF online — PDF911",
    "description": "CSV na PDF za darmo w przegladarce. Szybkie narzedzie PDF do codziennych dokumentow.",
    "h1": "CSV na PDF online",
    "lead": "Uzyj CSV na PDF online w przegladarce. Plik jest przetwarzany lokalnie, gdy narzedzie to obsluguje."
  },
  {
    "slug": "tr/csv-pdf",
    "appHash": "csv-to-pdf",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "CSV PDF online — PDF911",
    "description": "CSV PDF tarayicida ucretsiz. Gunluk belgeler icin hizli PDF araci.",
    "h1": "CSV PDF online",
    "lead": "CSV PDF aracini tarayicida online kullanin. Arac desteklediginde dosya cihazinizda yerel olarak islenir."
  },
  {
    "slug": "id/csv-ke-pdf",
    "appHash": "csv-to-pdf",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "CSV ke PDF online — PDF911",
    "description": "CSV ke PDF gratis langsung di browser. Alat PDF cepat untuk dokumen harian.",
    "h1": "CSV ke PDF online",
    "lead": "Gunakan CSV ke PDF online di browser. File diproses secara lokal jika alat mendukungnya."
  },
  {
    "slug": "ja/csv-pdf-henkan",
    "appHash": "csv-to-pdf",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "CSVからPDFオンライン — PDF911",
    "description": "CSVからPDFをブラウザで無料オンライン利用できます。日常のPDF文書に使える高速ツールです。",
    "h1": "CSVからPDFオンライン",
    "lead": "CSVからPDFをブラウザでオンライン利用できます。対応ツールではファイルを端末上でローカル処理します。"
  },
  {
    "slug": "vi/csv-sang-pdf",
    "appHash": "csv-to-pdf",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "CSV sang PDF online — PDF911",
    "description": "CSV sang PDF miễn phí ngay trong trình duyệt. Công cụ PDF nhanh cho tài liệu hằng ngày.",
    "h1": "CSV sang PDF online",
    "lead": "Dùng CSV sang PDF online trong trình duyệt. Khi công cụ hỗ trợ, tệp được xử lý cục bộ trên thiết bị của bạn."
  },
  {
    "slug": "ko/csv-pdf-byeonhwan",
    "appHash": "csv-to-pdf",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "온라인 CSV를 PDF로 — PDF911",
    "description": "CSV를 PDF로을 브라우저에서 무료로 사용하세요. 일상 문서를 위한 빠른 PDF 도구입니다.",
    "h1": "온라인 CSV를 PDF로",
    "lead": "브라우저에서 CSV를 PDF로을 온라인으로 사용하세요. 지원되는 도구에서는 파일이 기기에서 로컬로 처리됩니다."
  },
  {
    "slug": "ar/csv-ila-pdf",
    "appHash": "csv-to-pdf",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "CSV إلى PDF عبر الإنترنت — PDF911",
    "description": "CSV إلى PDF مجانا مباشرة في المتصفح. أداة PDF سريعة للمستندات اليومية.",
    "h1": "CSV إلى PDF عبر الإنترنت",
    "lead": "استخدم CSV إلى PDF عبر الإنترنت في المتصفح. عند دعم الأداة لذلك، تتم معالجة الملف محليا على جهازك."
  },
  {
    "slug": "hi/csv-se-pdf",
    "appHash": "csv-to-pdf",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "CSV से PDF ऑनलाइन — PDF911",
    "description": "CSV से PDF ब्राउज़र में मुफ्त इस्तेमाल करें। रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल।",
    "h1": "CSV से PDF ऑनलाइन",
    "lead": "ब्राउज़र में CSV से PDF ऑनलाइन इस्तेमाल करें। जहां टूल सपोर्ट करता है, फाइल आपके डिवाइस पर लोकली प्रोसेस होती है।"
  }
];

export const homeSeoPages: HomeSeoPage[] = [
  {
    "slug": "",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "PDF911 — Free Online PDF Tools",
    "description": "PDF911 is a free online PDF toolkit: merge, compress, split, edit, sign and convert PDF files directly in your browser.",
    "h1": "PDF911",
    "lead": "Fast PDF tools for everyday document work. Your files stay in the browser and are not uploaded to our server.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "ru",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "PDF911 — бесплатные PDF-инструменты онлайн",
    "description": "Объединяйте, сжимайте, разделяйте, редактируйте, подписывайте и конвертируйте PDF прямо в браузере.",
    "h1": "PDF911",
    "lead": "Быстрые PDF-инструменты для повседневной работы с документами. Файлы остаются в браузере.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "zh",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "PDF911 — 免费在线 PDF 工具",
    "description": "直接在浏览器中合并、压缩、拆分、编辑、签署和转换 PDF 文件。",
    "h1": "PDF911",
    "lead": "适合日常文档处理的快速 PDF 工具。文件保留在浏览器中，不会上传到我们的服务器。",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "es",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "PDF911 — Herramientas PDF online gratis",
    "description": "Une, comprime, divide, edita, firma y convierte archivos PDF online directamente en el navegador.",
    "h1": "PDF911",
    "lead": "Herramientas PDF rapidas para documentos diarios. Tus archivos permanecen en el navegador.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "pt",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "PDF911 — Ferramentas PDF online gratis",
    "description": "Junte, comprima, divida, edite, assine e converta arquivos PDF online diretamente no navegador.",
    "h1": "PDF911",
    "lead": "Ferramentas PDF rapidas para documentos do dia a dia. Seus arquivos ficam no navegador.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "de",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "PDF911 — Kostenlose Online-PDF-Tools",
    "description": "PDF online zusammenfugen, komprimieren, teilen, bearbeiten, unterschreiben und konvertieren.",
    "h1": "PDF911",
    "lead": "Schnelle PDF-Tools fur den Alltag. Ihre Dateien bleiben im Browser.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "fr",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "PDF911 — Outils PDF en ligne gratuits",
    "description": "Fusionnez, compressez, divisez, modifiez, signez et convertissez des PDF directement dans le navigateur.",
    "h1": "PDF911",
    "lead": "Des outils PDF rapides pour les documents du quotidien. Vos fichiers restent dans le navigateur.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "it",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "PDF911 — Strumenti PDF online gratis",
    "description": "Unisci, comprimi, dividi, modifica, firma e converti PDF online direttamente nel browser.",
    "h1": "PDF911",
    "lead": "Strumenti PDF rapidi per i documenti di ogni giorno. I file restano nel browser.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "nl",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "PDF911 — Gratis online PDF-tools",
    "description": "PDF-bestanden online samenvoegen, comprimeren, splitsen, bewerken, ondertekenen en converteren.",
    "h1": "PDF911",
    "lead": "Snelle PDF-tools voor dagelijks documentwerk. Uw bestanden blijven in de browser.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "pl",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "PDF911 — Darmowe narzedzia PDF online",
    "description": "Lacz, kompresuj, dziel, edytuj, podpisuj i konwertuj pliki PDF online w przegladarce.",
    "h1": "PDF911",
    "lead": "Szybkie narzedzia PDF do codziennej pracy z dokumentami. Pliki pozostaja w przegladarce.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "tr",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "PDF911 — Ucretsiz online PDF araclari",
    "description": "PDF dosyalarini tarayicida birlestirin, sikistirin, bolun, duzenleyin, imzalayin ve donusturun.",
    "h1": "PDF911",
    "lead": "Gunluk belgeler icin hizli PDF araclari. Dosyalariniz tarayicida kalir.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "id",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "PDF911 — Alat PDF online gratis",
    "description": "Gabungkan, kompres, pisahkan, edit, tanda tangani, dan konversi PDF langsung di browser.",
    "h1": "PDF911",
    "lead": "Alat PDF cepat untuk pekerjaan dokumen harian. File Anda tetap berada di browser.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "ja",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "PDF911 — 無料オンラインPDFツール",
    "description": "PDFの結合、圧縮、分割、編集、署名、変換をブラウザだけで行えます。",
    "h1": "PDF911",
    "lead": "日常の文書作業に使える高速PDFツール。ファイルはブラウザ内に残り、サーバーへアップロードされません。",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "vi",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "PDF911 — Công cụ PDF online miễn phí",
    "description": "Gộp, nén, tách, chỉnh sửa, ký và chuyển đổi PDF trực tiếp trong trình duyệt.",
    "h1": "PDF911",
    "lead": "Công cụ PDF nhanh cho công việc tài liệu hằng ngày. Tệp của bạn vẫn ở trong trình duyệt.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "ko",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "PDF911 — 무료 온라인 PDF 도구",
    "description": "브라우저에서 PDF 병합, 압축, 분할, 편집, 서명, 변환을 바로 처리하세요.",
    "h1": "PDF911",
    "lead": "일상 문서 작업을 위한 빠른 PDF 도구입니다. 파일은 브라우저에 남아 서버로 업로드되지 않습니다.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "ar",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "PDF911 — أدوات PDF مجانية عبر الإنترنت",
    "description": "ادمج واضغط واقسم وحرر ووقع وحول ملفات PDF مباشرة في المتصفح.",
    "h1": "PDF911",
    "lead": "أدوات PDF سريعة للعمل اليومي على المستندات. تبقى ملفاتك داخل المتصفح ولا يتم رفعها إلى خادمنا.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  },
  {
    "slug": "hi",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "PDF911 — मुफ्त ऑनलाइन PDF टूल",
    "description": "PDF को ब्राउज़र में ही मिलाएं, कंप्रेस करें, बांटें, एडिट करें, साइन करें और कन्वर्ट करें।",
    "h1": "PDF911",
    "lead": "रोज़मर्रा के दस्तावेज़ों के लिए तेज PDF टूल। आपकी फाइलें ब्राउज़र में रहती हैं और हमारे सर्वर पर अपलोड नहीं होतीं।",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/"
      }
    ]
  }
];

export const privacySeoPages: PrivacySeoPage[] = [
  {
    "slug": "privacy",
    "lang": "en-US",
    "hreflang": "en-US",
    "locale": "en_US",
    "languageName": "English",
    "title": "Privacy Policy - PDF911",
    "description": "PDF911 privacy policy: files are processed locally in the browser and are not uploaded to our server.",
    "h1": "Privacy Policy",
    "lead": "PDF911 is designed around browser-side PDF processing. This page explains what the current site does not collect, what can be stored in the browser and what technical data a production server may receive.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "ru/privacy",
    "lang": "ru",
    "hreflang": "ru",
    "locale": "ru_RU",
    "languageName": "Русский",
    "title": "Политика конфиденциальности - PDF911",
    "description": "Политика конфиденциальности PDF911: файлы обрабатываются локально в браузере и не загружаются на наш сервер.",
    "h1": "Политика конфиденциальности",
    "lead": "PDF911 устроен вокруг обработки PDF прямо в браузере. На этой странице объясняется, какие данные текущий сайт не собирает, что может храниться в браузере и какие технические данные может получать сервер.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "zh/privacy",
    "lang": "zh-CN",
    "hreflang": "zh-CN",
    "locale": "zh_CN",
    "languageName": "中文",
    "title": "隐私政策 - PDF911",
    "description": "PDF911 隐私政策：文件在浏览器中本地处理，不会上传到我们的服务器。",
    "h1": "隐私政策",
    "lead": "PDF911 围绕浏览器端 PDF 处理而设计。本页说明当前网站不会收集什么、浏览器中可能存储什么，以及生产服务器可能接收哪些技术数据。",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "es/privacy",
    "lang": "es",
    "hreflang": "es",
    "locale": "es_ES",
    "languageName": "Español",
    "title": "Politica de privacidad - PDF911",
    "description": "Politica de privacidad de PDF911: los archivos se procesan localmente en el navegador y no se suben a nuestro servidor.",
    "h1": "Politica de privacidad",
    "lead": "PDF911 esta disenado alrededor del procesamiento de PDF en el navegador. Esta pagina explica que no recopila el sitio actual, que puede guardarse en el navegador y que datos tecnicos puede recibir un servidor de produccion.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "pt/privacy",
    "lang": "pt-BR",
    "hreflang": "pt-BR",
    "locale": "pt_BR",
    "languageName": "Português",
    "title": "Politica de privacidade - PDF911",
    "description": "Politica de privacidade do PDF911: os arquivos sao processados localmente no navegador e nao sao enviados ao nosso servidor.",
    "h1": "Politica de privacidade",
    "lead": "O PDF911 foi criado em torno do processamento de PDF no navegador. Esta pagina explica o que o site atual nao coleta, o que pode ser armazenado no navegador e quais dados tecnicos um servidor de producao pode receber.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "de/privacy",
    "lang": "de",
    "hreflang": "de",
    "locale": "de_DE",
    "languageName": "Deutsch",
    "title": "Datenschutzerklaerung - PDF911",
    "description": "PDF911 Datenschutzerklaerung: Dateien werden lokal im Browser verarbeitet und nicht auf unseren Server hochgeladen.",
    "h1": "Datenschutzerklaerung",
    "lead": "PDF911 ist auf PDF-Verarbeitung im Browser ausgelegt. Diese Seite erklaert, was die aktuelle Website nicht sammelt, was im Browser gespeichert werden kann und welche technischen Daten ein Produktionsserver erhalten kann.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "fr/privacy",
    "lang": "fr",
    "hreflang": "fr",
    "locale": "fr_FR",
    "languageName": "Français",
    "title": "Politique de confidentialite - PDF911",
    "description": "Politique de confidentialite PDF911 : les fichiers sont traites localement dans le navigateur et ne sont pas envoyes a notre serveur.",
    "h1": "Politique de confidentialite",
    "lead": "PDF911 est concu autour du traitement des PDF cote navigateur. Cette page explique ce que le site actuel ne collecte pas, ce qui peut etre stocke dans le navigateur et quelles donnees techniques un serveur de production peut recevoir.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "it/privacy",
    "lang": "it",
    "hreflang": "it",
    "locale": "it_IT",
    "languageName": "Italiano",
    "title": "Informativa sulla privacy - PDF911",
    "description": "Informativa sulla privacy di PDF911: i file vengono elaborati localmente nel browser e non sono caricati sul nostro server.",
    "h1": "Informativa sulla privacy",
    "lead": "PDF911 e progettato attorno all'elaborazione dei PDF nel browser. Questa pagina spiega cosa il sito attuale non raccoglie, cosa puo essere memorizzato nel browser e quali dati tecnici puo ricevere un server di produzione.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "nl/privacy",
    "lang": "nl",
    "hreflang": "nl",
    "locale": "nl_NL",
    "languageName": "Nederlands",
    "title": "Privacybeleid - PDF911",
    "description": "Privacybeleid van PDF911: bestanden worden lokaal in de browser verwerkt en niet naar onze server geupload.",
    "h1": "Privacybeleid",
    "lead": "PDF911 is gebouwd rond PDF-verwerking in de browser. Deze pagina legt uit wat de huidige site niet verzamelt, wat in de browser kan worden opgeslagen en welke technische gegevens een productieserver kan ontvangen.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "pl/privacy",
    "lang": "pl",
    "hreflang": "pl",
    "locale": "pl_PL",
    "languageName": "Polski",
    "title": "Polityka prywatnosci - PDF911",
    "description": "Polityka prywatnosci PDF911: pliki sa przetwarzane lokalnie w przegladarce i nie sa wysylane na nasz serwer.",
    "h1": "Polityka prywatnosci",
    "lead": "PDF911 opiera sie na przetwarzaniu PDF w przegladarce. Ta strona wyjasnia, czego obecny serwis nie zbiera, co moze byc zapisane w przegladarce i jakie dane techniczne moze otrzymac serwer produkcyjny.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "tr/privacy",
    "lang": "tr",
    "hreflang": "tr",
    "locale": "tr_TR",
    "languageName": "Türkçe",
    "title": "Gizlilik politikasi - PDF911",
    "description": "PDF911 gizlilik politikasi: dosyalar tarayicida yerel olarak islenir ve sunucumuza yuklenmez.",
    "h1": "Gizlilik politikasi",
    "lead": "PDF911, PDF islemlerini tarayici tarafinda yapacak sekilde tasarlanmistir. Bu sayfa mevcut sitenin neleri toplamadigini, tarayicida nelerin saklanabilecegini ve bir uretim sunucusunun hangi teknik verileri alabilecegini aciklar.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "id/privacy",
    "lang": "id",
    "hreflang": "id",
    "locale": "id_ID",
    "languageName": "Bahasa Indonesia",
    "title": "Kebijakan privasi - PDF911",
    "description": "Kebijakan privasi PDF911: file diproses secara lokal di browser dan tidak diunggah ke server kami.",
    "h1": "Kebijakan privasi",
    "lead": "PDF911 dirancang di sekitar pemrosesan PDF di sisi browser. Halaman ini menjelaskan apa yang tidak dikumpulkan situs saat ini, apa yang dapat disimpan di browser, dan data teknis apa yang dapat diterima server produksi.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "ja/privacy",
    "lang": "ja",
    "hreflang": "ja",
    "locale": "ja_JP",
    "languageName": "日本語",
    "title": "プライバシーポリシー - PDF911",
    "description": "PDF911 のプライバシーポリシー: ファイルはブラウザ内でローカル処理され、当社サーバーへアップロードされません。",
    "h1": "プライバシーポリシー",
    "lead": "PDF911 はブラウザ側での PDF 処理を中心に設計されています。このページでは、現在のサイトが収集しない情報、ブラウザに保存される可能性がある情報、本番サーバーが受け取る可能性がある技術データについて説明します。",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "vi/privacy",
    "lang": "vi",
    "hreflang": "vi",
    "locale": "vi_VN",
    "languageName": "Tiếng Việt",
    "title": "Chinh sach quyen rieng tu - PDF911",
    "description": "Chinh sach quyen rieng tu PDF911: tep duoc xu ly cuc bo trong trinh duyet va khong duoc tai len may chu cua chung toi.",
    "h1": "Chinh sach quyen rieng tu",
    "lead": "PDF911 duoc thiet ke xoay quanh viec xu ly PDF trong trinh duyet. Trang nay giai thich trang hien tai khong thu thap gi, nhung gi co the duoc luu trong trinh duyet va may chu san xuat co the nhan du lieu ky thuat nao.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "ko/privacy",
    "lang": "ko",
    "hreflang": "ko",
    "locale": "ko_KR",
    "languageName": "한국어",
    "title": "개인정보 처리방침 - PDF911",
    "description": "PDF911 개인정보 처리방침: 파일은 브라우저에서 로컬로 처리되며 당사 서버로 업로드되지 않습니다.",
    "h1": "개인정보 처리방침",
    "lead": "PDF911은 브라우저 측 PDF 처리를 중심으로 설계되었습니다. 이 페이지는 현재 사이트가 수집하지 않는 정보, 브라우저에 저장될 수 있는 정보, 운영 서버가 받을 수 있는 기술 데이터를 설명합니다.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "ar/privacy",
    "lang": "ar",
    "hreflang": "ar",
    "locale": "ar_AR",
    "languageName": "العربية",
    "title": "سياسة الخصوصية - PDF911",
    "description": "سياسة خصوصية PDF911: تتم معالجة الملفات محليا في المتصفح ولا يتم رفعها إلى خادمنا.",
    "h1": "سياسة الخصوصية",
    "lead": "تم تصميم PDF911 حول معالجة ملفات PDF داخل المتصفح. توضح هذه الصفحة ما لا يجمعه الموقع الحالي، وما يمكن تخزينه في المتصفح، وما البيانات التقنية التي قد يتلقاها خادم الإنتاج.",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  },
  {
    "slug": "hi/privacy",
    "lang": "hi",
    "hreflang": "hi",
    "locale": "hi_IN",
    "languageName": "हिन्दी",
    "title": "प्राइवेसी पॉलिसी - PDF911",
    "description": "PDF911 प्राइवेसी पॉलिसी: फाइलें ब्राउज़र में लोकली प्रोसेस होती हैं और हमारे सर्वर पर अपलोड नहीं होतीं।",
    "h1": "प्राइवेसी पॉलिसी",
    "lead": "PDF911 ब्राउज़र-साइड PDF प्रोसेसिंग के आसपास बनाया गया है। यह पेज बताता है कि मौजूदा साइट क्या इकट्ठा नहीं करती, ब्राउज़र में क्या स्टोर हो सकता है और production server कौन सा तकनीकी डेटा प्राप्त कर सकता है।",
    "alternates": [
      {
        "hreflang": "en-US",
        "href": "https://pdf911.com/privacy/"
      },
      {
        "hreflang": "ru",
        "href": "https://pdf911.com/ru/privacy/"
      },
      {
        "hreflang": "zh-CN",
        "href": "https://pdf911.com/zh/privacy/"
      },
      {
        "hreflang": "es",
        "href": "https://pdf911.com/es/privacy/"
      },
      {
        "hreflang": "pt-BR",
        "href": "https://pdf911.com/pt/privacy/"
      },
      {
        "hreflang": "de",
        "href": "https://pdf911.com/de/privacy/"
      },
      {
        "hreflang": "fr",
        "href": "https://pdf911.com/fr/privacy/"
      },
      {
        "hreflang": "it",
        "href": "https://pdf911.com/it/privacy/"
      },
      {
        "hreflang": "nl",
        "href": "https://pdf911.com/nl/privacy/"
      },
      {
        "hreflang": "pl",
        "href": "https://pdf911.com/pl/privacy/"
      },
      {
        "hreflang": "tr",
        "href": "https://pdf911.com/tr/privacy/"
      },
      {
        "hreflang": "id",
        "href": "https://pdf911.com/id/privacy/"
      },
      {
        "hreflang": "ja",
        "href": "https://pdf911.com/ja/privacy/"
      },
      {
        "hreflang": "vi",
        "href": "https://pdf911.com/vi/privacy/"
      },
      {
        "hreflang": "ko",
        "href": "https://pdf911.com/ko/privacy/"
      },
      {
        "hreflang": "ar",
        "href": "https://pdf911.com/ar/privacy/"
      },
      {
        "hreflang": "hi",
        "href": "https://pdf911.com/hi/privacy/"
      },
      {
        "hreflang": "x-default",
        "href": "https://pdf911.com/privacy/"
      }
    ]
  }
];
